import {Injectable} from '@angular/core';
import {QueryEntity} from '@datorama/akita';
import {TransporterDiscountState, Store} from './store';

@Injectable({ providedIn: 'root' })
export class TransporterDiscountQuery extends QueryEntity<TransporterDiscountState> {

  constructor(protected store: Store) {
    super(store);
  }

}
